import { a as mdiCheck, e as mdiContentCopy } from "./mdi-CgetWrFc.mjs";
import { toValue } from "@vueuse/core";
import { ref, computed } from "vue";
import { r as register, d as t21, a as t } from "./_l10n-D3tJt_gL.mjs";
register(t21);
/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const DELAY = 2e3;
function useCopy(content) {
  const isCopied = ref(false);
  const icon = computed(() => isCopied.value ? mdiCheck : mdiContentCopy);
  const altText = computed(() => isCopied.value ? t("Copied") : t("Copy to clipboard"));
  async function copy() {
    if (isCopied.value) {
      return;
    }
    const value = toValue(content);
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      prompt("", value);
    }
    isCopied.value = true;
    setTimeout(() => {
      isCopied.value = false;
    }, DELAY);
  }
  return {
    isCopied,
    copy,
    icon,
    altText
  };
}
export {
  useCopy as u
};
//# sourceMappingURL=useCopy-J3zJ3s94.mjs.map
